import { useUpdateEffect } from '@lbcamden/lib-react';
import { useLocation } from 'react-router';

import { api } from '~/client/lib/trpc';
import { useAppStore } from '~/client/store/app/appStore';

const refetchInterval = 3e5; // 5 mins

export const useDetectIsOnCamdenNetwork = () => {
  const { pathname } = useLocation();

  const setIsOnCamdenNetwork = useAppStore((state) => state.setIsOnCamdenNetwork);

  const { data: isOnCamdenNetwork, refetch } = api.isOnCamdenNetwork.useQuery(undefined, {
    refetchInterval,
  });

  useUpdateEffect(() => {
    void refetch();
  }, [pathname]);

  useUpdateEffect(() => {
    setIsOnCamdenNetwork(isOnCamdenNetwork);
  }, [isOnCamdenNetwork]);
};
